import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbPipsTradeApp = () => {
  return (
    <div
      className="ht__bradcaump__area__platform"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>The Pips Trade App</h1>
              <p>
                Your trading. Your control. Anywhere, anytime. Experience
                seamless trading powered by precision, speed, and security, all
                in one app.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Download the App
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbPipsTradeApp.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbPipsTradeApp;
